export default __webpack_public_path__ + "static/media/thumb_13.e776fe36.webp";